import React from 'react';
import PropTypes from 'prop-types';
import displayName from 'component-lib/displayName';
import styles from './Lists.scss';

function List({ children, type }) {
    return (<ul className={styles[`list-${type}`]}>
        {children}
    </ul>)
}

List.displayName = displayName('Lists/List');

List.propTypes = {
    children: PropTypes.node.isRequired,
    type: PropTypes.oneOf([
        'none',
        'disc',
        'circle',
        'square',
        'decimal',
        'decimal-leading-zero',
        'lower-roman',
        'upper-roman',
        'lower-alpha',
        'upper-alpha',
        'checklist',
    ]),
};

List.defaultProps = {
    type: 'disc',
};

export default List;
